webpackJsonp([1],{

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(417)
}
var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(430),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vux_src_plugins_ajax_index_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_alert_index_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_sticky_index_vue__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vux_src_components_sticky_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vux_src_components_sticky_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_tab_tab_vue__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vux_src_components_tab_tab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vux_src_components_tab_tab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_tab_tab_item_vue__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vux_src_components_tab_tab_item_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vux_src_components_tab_tab_item_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_toast_index_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_view_box_index_vue__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vux_src_components_view_box_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vux_src_components_view_box_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vux_src_plugins_wechat_index_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_dialog_index_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_dialog_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_dialog_index_vue__);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Sticky', __WEBPACK_IMPORTED_MODULE_4_vux_src_components_sticky_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('Tab', __WEBPACK_IMPORTED_MODULE_5_vux_src_components_tab_tab_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('TabItem', __WEBPACK_IMPORTED_MODULE_6_vux_src_components_tab_tab_item_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('ViewBox', __WEBPACK_IMPORTED_MODULE_8_vux_src_components_view_box_index_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('XDialog', __WEBPACK_IMPORTED_MODULE_10_vux_src_components_x_dialog_index_vue___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vux_src_plugins_ajax_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vux_src_plugins_alert_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vux_src_plugins_wechat_index_js__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vux_src_plugins_toast_index_js__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__x_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__x_dialog__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'alert',
  components: {
    XDialog: __WEBPACK_IMPORTED_MODULE_0__x_dialog___default.a
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    }
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});

/***/ }),

/***/ 183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sticky__ = __webpack_require__(192);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sticky',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sticky__["a" /* default */])(_this.$el, {
        scrollBox: _this.scrollBox,
        offset: _this.offset,
        checkStickySupport: typeof _this.checkStickySupport === 'undefined' ? true : _this.checkStickySupport
      });
    });
  },

  props: ['scrollBox', 'offset', 'checkStickySupport']
});

/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__ = __webpack_require__(123);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tab-item',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__ = __webpack_require__(123);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tab',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_multi_items__["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String]
  },
  computed: {
    barLeft: function barLeft() {
      return this.currentIndex * (100 / this.number) + '%';
    },
    barRight: function barRight() {
      return (this.number - this.currentIndex - 1) * (100 / this.number) + '%';
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        backgroundColor: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.backgroundColor = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.backgroundColor = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  }
});

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__ = __webpack_require__(194);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'toast',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_safari_fix__["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});

/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'x-dialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.currentValue = val;
      },
      immediate: true
    },
    currentValue: function currentValue(val) {
      this.$emit(val ? 'on-show' : 'on-hide');
      this.$emit('input', val);
    }
  },
  data: function data() {
    return {
      currentValue: false
    };
  },

  methods: {
    onTouchMove: function onTouchMove(event) {
      !this.scroll && event.preventDefault();
    }
  }
});

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PrimaryBtn__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PrimaryBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_PrimaryBtn__);


var _components;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import Hr from './components/Hr'

// import URL from './utils/URL'

// 上线开关
var producttion = true;

// 获取用户的code
// const code = URL.getQueryString('code')
var host = producttion ? 'http://m.wkbins.com/' : 'http://test.m.wkbins.com/';
var wkbInnerCode = producttion ? '148198068433580000' : '149673178664394306';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      title: '【8.1保险节】悟空保2周年庆第二单9折专题活动',
      // openId: '',
      // appid: 'wxef64cfa3a28363ac', // 正式
      // appid: 'wx71f5c7fb1d47af54', // 测试
      appid: producttion ? 'wxef64cfa3a28363ac' : 'wx71f5c7fb1d47af54',
      showMyPriceDialog: false,
      // posterActivityId: '201707261147010', // 海报活动id
      scratchActivityId: '201707261147003', // 刮刮乐活动id
      bookingActivityId: '201707261147002', // 早订早优惠活动id
      shareDesc: '活动期间下单再赠9折通用券，全场产品即可立享折上折，机会不能错过，赶紧抢~',
      activities: [{
        type: 'seckill',
        title: '第二单九折',
        previewImg: 'static/images/seckill-product.png',
        rules: ['活动时间：8月1日-8月18日；', '使用规则：活动期间购买专题中任一产品（秒杀产品除外）后，即可获得9折通用券一张。该券属于通用券，可购买专题任一产品（秒杀产品除外），可参与专题产品折扣叠加。所有优惠劵一经使用，不退补，不找零；', '优惠方式：保险产品下单时需全款支付，且过犹豫期未退保，产生的优惠金额将以返现方式发送至您的悟空保账户中。关注悟空保微信公众号iwukongbao，点击“我的>个人中心>我的钱包”，请使用投保手机号登录查看返现金额，返现金额待运营人员审核通过后即可提现。如果犹豫期退保，则所有优惠券自动作废，优惠额度随即取消；', '使用时间：9折通用券有效时间为8月1日至8月18日。']
      }, {
        type: 'booking',
        title: '8.1元兑换区',
        rules: ['活动时间：8月1日-8月18日；', '活动范围：7月28日至7月31日，通过8.1元参加预订活动的用户，可以在“8.1元兑换专区”参与9折优惠兑换活动，限购买成人版重疾险、少儿版重疾险产品；', '使用规则：未提前预订的用户，可直接购买享9折优惠；已付8.1元购买9折定向券的用户，可在产品9折基础上，叠加使用9折定向券，以及其他现金券多重优惠叠加购买；所有优惠券一经使用，不退补，不找零；', '优惠方式：保险产品下单时需全款支付，且过犹豫期未退保，产生的优惠金额将以返现方式发送至您的悟空保账户中。关注悟空保微信公众号iwukongbao，点击“我的>个人中心>我的钱包”，请使用投保手机号登录查看返现金额，返现金额待运营人员审核通过后即可提现。如果犹豫期退保，则所有优惠券自动作废，优惠额度随即取消。']
      }, {
        type: 'scratch',
        title: '两周年专区',
        rules: ['活动时间：8月1日-8月18日；', '使用规则：用户可以在产品价格8折基础上，同时叠加使用其他现金券和通用券。所有优惠券一经使用，不退补，不找零；', '优惠方式：保险产品下单时需全款支付，且过犹豫期未退保，产生的优惠金额将以返现方式发送至您的悟空保账户中。关注悟空保微信公众号iwukongbao，点击“我的>个人中心>我的钱包”，请使用投保手机号登录查看返现金额，返现金额待运营人员审核通过后即可提现。如果犹豫期退保，则所有优惠券自动作废，优惠额度随即取消。']
      }],
      showFixedBtn: false,
      showRules: false,
      currentRule: 0,
      bookingList: [{
        previewImg: 'static/images/booking_1.png',
        title: '【成人版】重疾险',
        link: host + 'activityProduct/insurePolicy/' + wkbInnerCode + '/150122972795448349?requireJsApi=true&bomb=1',
        dess: ['覆盖上班族高发50种以上重疾，最高直降800元，确诊即赔', '买就送500元基因检测'],
        lowestPrice: '792元/年起'
      }, {
        previewImg: 'static/images/booking_2.png',
        title: '【少儿版】重疾险',
        link: host + 'activityProduct/insurePolicy/' + wkbInnerCode + '/150122979463900132?requireJsApi=true&bomb=1',
        dess: ['覆盖少儿高发42种以上重疾，保障终身，确诊即赔', '买就送500元基因检测'],
        lowestPrice: '414元/年起'
      }],
      specialList: [{
        previewImg: 'static/images/special_1.png',
        title: '至尊保定期寿险',
        link: host + 'hengqin/#/' + wkbInnerCode + '/149674766585200396',
        dess: ['性价比完胜香港保险，按需灵活投保，保障最优，价格最低，后顾无忧'],
        lowestPrice: '105元/年起'
      }, {
        previewImg: 'static/images/special_2.png',
        title: '至尊保定期意外险',
        link: host + 'hqdy/#/' + wkbInnerCode + '/149792885824813849',
        dess: ['价格行业最低，免检保额最高、按需灵活投保，责任涵盖伤残'],
        lowestPrice: '249元/年起'
      }, {
        previewImg: 'static/images/special_3.png',
        title: '至尊保百万医疗险',
        link: host + 'activityProduct/insurePolicy/' + wkbInnerCode + '/149421366832021029?requireJsApi=true&bomb=1',
        dess: ['百万保额，百元价格，投保三年，可续保到百岁'],
        lowestPrice: '117元起'
      }, {
        previewImg: 'static/images/special_4.png',
        title: '至尊保终身寿险',
        link: host + 'activityProduct/insurePolicy/' + wkbInnerCode + '/149251955998404923?requireJsApi=true',
        dess: ['首创交至百岁,免检保额最高,价格行业最低,责任涵盖全残'],
        lowestPrice: '270元/年起'
      }, {
        previewImg: 'static/images/special_5.png',
        title: '至尊保终身意外险',
        link: host + 'activityProduct/insurePolicy/' + wkbInnerCode + '/149329577605090390?requireJsApi=true&bomb=1',
        dess: ['首创终身意外险, 老有所保,涵盖意外身故、全残和伤残'],
        lowestPrice: '240元起'
      }]
    };
  },

  computed: {
    redirectURI: function redirectURI() {
      return host + '/anniversaries/2017/discount';
    }
  },
  components: (_components = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_2__components_PrimaryBtn___default.a.name, __WEBPACK_IMPORTED_MODULE_2__components_PrimaryBtn___default.a), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components, __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue___default.a.name, __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue___default.a), _components),
  created: function created() {
    var _this = this;

    // 微信接口权限配置
    var url = encodeURIComponent(window.location.href.replace(/#.+$/, '')); // 最后的 / 一定要有
    this.$http.get('/api/hqdqx/getJsApiInfo?projectUrl=' + url).then(function (response) {
      // 分享
      var shareData = {
        title: _this.title,
        desc: _this.shareDesc,
        // link: authorizationURL,
        imgUrl: window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + 'static/images/share.png'
      };
      _this.$wechat.ready(function () {
        // 分享给朋友
        _this.$wechat.onMenuShareAppMessage({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareData.imgUrl // 分享图标
        });
        // 分享到朋友圈
        _this.$wechat.onMenuShareTimeline({
          title: shareData.title, // 分享标题
          link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareData.imgUrl // 分享图标
        });
        // 分享到QQ
        _this.$wechat.onMenuShareQQ({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link, // 分享链接
          imgUrl: shareData.imgUrl // 分享图标
        });
        // 分享到腾讯微博
        _this.$wechat.onMenuShareWeibo({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link, // 分享链接
          imgUrl: shareData.imgUrl // 分享图标
        });
      });
      _this.$wechat.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: response.data.appId, // 必填，公众号的唯一标识
        timestamp: response.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
        signature: response.data.signature, // 必填，签名，见附录1
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    /**
     * 标题
     */
    document.title = this.title;

    window.onload = function () {
      /**
       * 导航占位符的高度
       */
      window.$('.nav-placeholder').css('height', window.$('.nav-placeholder .nav').height());

      /**
       * 滚动页面
       */
      var scroller = _this2.$refs.scroller;
      var scrollBody = scroller.getScrollBody();
      // 目标距离页面顶部的距离
      var targets = [];
      window.$('.activity').each(function () {
        targets.push(window.$(this)[0].offsetTop);
      });
      // 导航的高度
      var navHeight = window.$('.nav').height();
      window.$(scrollBody).scroll(function () {
        // 当前滚动的距离
        var currentScrollTop = scroller.getScrollTop();

        // 悬浮按钮
        if (currentScrollTop >= 300) {
          _this2.showFixedBtn = true;
        } else {
          _this2.showFixedBtn = false;
        }

        for (var i = targets.length - 1, l = 0; i >= l; i--) {
          if (currentScrollTop < targets[0] - navHeight) {
            window.$('.nav li').removeClass('active');
            window.$('.nav li').each(function () {
              window.$(this).find('img').attr('src', window.$(this).index() % 2 === 0 ? 'static/images/nav_odd.png' : 'static/images/nav_even.png');
            });
            return;
          }
          if (currentScrollTop >= targets[i] - navHeight) {
            window.$('.nav li').removeClass('active');
            window.$('.nav li').eq(i).addClass('active');
            window.$('.nav li').each(function () {
              window.$(this).find('img').attr('src', window.$(this).index() % 2 === 0 ? 'static/images/nav_odd.png' : 'static/images/nav_even.png');
            });
            window.$('.nav li img').eq(i).attr('src', i % 2 === 0 ? 'static/images/nav_odd_active.png' : 'static/images/nav_even_active.png');
            return;
          }
        }
      });
      // 点击导航
      window.$('.nav li').click(function () {
        scroller.scrollTo(targets[window.$(this).index()] - navHeight + 1);
      });
    };

    window.$(window).bind('orientationchange', function () {
      location.href = location.href;
    });
  },

  methods: {
    scrollTop: function scrollTop() {
      this.$refs.scroller.scrollTo(0);
    },
    goToBookingPage: function goToBookingPage(obj, index) {
      window.location.href = this[obj][index].link;
    }
  }
});

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-footer'
});

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'm-primary-btn',
  props: ['text', 'status'],
  methods: {
    clickHandler: function clickHandler() {
      this.$emit('click');
    }
  }
});

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-tab",
    class: {
      'vux-tab-no-animate': !_vm.animate
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.animate) ? _c('div', {
    staticClass: "vux-tab-ink-bar",
    class: _vm.barClass,
    style: (_vm.barStyle)
  }, [(_vm.customBarWidth) ? _c('span', {
    staticClass: "vux-tab-bar-inner",
    style: (_vm.innerBarStyle)
  }) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-tab"
  }, [_vm._t("header"), _vm._v(" "), _c('div', {
    ref: "viewBoxBody",
    staticClass: "weui-tab__panel vux-fix-safari-overflow-scrolling",
    style: ({
      paddingTop: _vm.bodyPaddingTop,
      paddingBottom: _vm.bodyPaddingBottom
    }),
    attrs: {
      "id": "vux_view_box_body"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("bottom")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-x-dialog",
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.maskTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticClass: "weui-mask",
    on: {
      "click": function($event) {
        _vm.hideOnBlur && (_vm.currentValue = false)
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.dialogTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    class: _vm.dialogClass,
    style: (_vm.dialogStyle)
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "primary-btn",
    class: {
      status0: _vm.status === 0, status2: _vm.status === 2
    }
  }, [_c('p', {
    attrs: {
      "id": "bd-share-poster"
    },
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-toast"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowMask && _vm.show),
      expression: "isShowMask && show"
    }],
    staticClass: "weui-mask_transparent"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "weui-toast",
    class: _vm.toastClass,
    style: ({
      width: _vm.width
    })
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'text'),
      expression: "type !== 'text'"
    }],
    staticClass: "weui-icon-success-no-circle weui-icon_toast"
  }), _vm._v(" "), (_vm.text) ? _c('p', {
    staticClass: "weui-toast__content",
    style: (_vm.style),
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._t("default")], 2)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-sticky-box"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('p', [_vm._v("Copyright "), _c('span'), _vm._v(" 2017, Wkbins Digital Co., Ltd. All Rights Reserved")]), _vm._v(" "), _c('p', [_vm._v("活动最终解释权归北京悟空保科技有限公司所有")])])
}]}

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-alert"
  }, [_c('x-dialog', {
    attrs: {
      "mask-transition": _vm.maskTransition,
      "dialog-transition": _vm.dialogTransition
    },
    on: {
      "on-hide": function($event) {
        _vm.$emit('on-hide')
      },
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.showValue),
      callback: function($$v) {
        _vm.showValue = $$v
      },
      expression: "showValue"
    }
  }, [_c('div', {
    staticClass: "weui-dialog__hd"
  }, [_c('strong', {
    staticClass: "weui-dialog__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__bd"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm._onHide
    }
  }, [_vm._v(_vm._s(_vm.buttonText || '确定'))])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('view-box', {
    ref: "scroller",
    attrs: {
      "body-padding-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/banner.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/wkb_logo.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/timeline.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav-placeholder"
  }, [_c('sticky', {
    attrs: {
      "scroll-box": "vux_view_box_body",
      "check-sticky-support": false
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, _vm._l((_vm.activities), function(activity, index) {
    return _c('li', {
      key: index,
      staticClass: "cf"
    }, [(index % 2 === 0) ? _c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/nav_odd.png"
      }
    }) : _vm._e(), _vm._v(" "), (index % 2 === 1) ? _c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/nav_even.png"
      }
    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(activity.title))])])
  }))])], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_vm._l((_vm.activities), function(activity, index) {
    return _c('div', {
      key: index,
      staticClass: "activity"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('div', {
      staticClass: "outer-title"
    }, [_c('div', {
      staticClass: "inner-title"
    }, [_vm._v(_vm._s(activity.title))])])]), _vm._v(" "), (activity.type === 'seckill') ? _c('div', [_c('div', {
      staticClass: "body"
    }, [_c('div', {
      staticClass: "cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/activity_top.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "main"
    }, [_c('div', {
      staticClass: "pre-seckill"
    }, [_c('div', {
      staticClass: "previes-img cf",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": activity.previewImg
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/activity_bottom.png"
      }
    })])])]) : _vm._e(), _vm._v(" "), (activity.type === 'booking') ? _c('div', _vm._l((_vm.bookingList), function(list, index) {
      return _c('div', {
        key: index,
        staticClass: "body body-booking"
      }, [_c('div', {
        staticClass: "cf"
      }, [_c('img', {
        staticClass: "response fl",
        attrs: {
          "src": "static/images/activity_top.png"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "main"
      }, [_c('div', {
        staticClass: "booking cf",
        on: {
          "click": function($event) {
            _vm.goToBookingPage('bookingList', index)
          }
        }
      }, [_c('div', {
        staticClass: "left fl"
      }, [_c('img', {
        staticClass: "response fl",
        attrs: {
          "src": list.previewImg
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "icon",
        attrs: {
          "src": "static/images/booking_new.png"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "right fr"
      }, [_c('div', {
        staticClass: "des"
      }, [_c('p', {
        staticClass: "des-title"
      }, [_vm._v(_vm._s(list.title))]), _vm._v(" "), _vm._l((list.dess), function(des, index) {
        return _c('p', {
          key: index,
          staticClass: "des-features"
        }, [_vm._v(_vm._s(des))])
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "appointment cf"
      }, [_c('p', {
        staticClass: "price fl"
      }, [_vm._v(_vm._s(list.lowestPrice))]), _vm._v(" "), _c('span', {
        staticClass: "btn fr"
      }, [_vm._v("立即购买")])])])])]), _vm._v(" "), _c('div', {
        staticClass: "cf"
      }, [_c('img', {
        staticClass: "response fl",
        attrs: {
          "src": "static/images/activity_bottom.png"
        }
      })])])
    })) : _vm._e(), _vm._v(" "), (activity.type === 'scratch') ? _c('div', [_c('div', {
      staticClass: "special body body-booking"
    }, [_c('div', {
      staticClass: "cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/activity_top.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "main"
    }, _vm._l((_vm.specialList), function(list, index) {
      return _c('div', {
        key: index,
        staticClass: "booking cf",
        on: {
          "click": function($event) {
            _vm.goToBookingPage('specialList', index)
          }
        }
      }, [_c('div', {
        staticClass: "left fl"
      }, [_c('img', {
        staticClass: "response fl",
        attrs: {
          "src": list.previewImg
        }
      }), _vm._v(" "), _c('img', {
        staticClass: "icon",
        attrs: {
          "src": "static/images/booking_new_2.png"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "right fr"
      }, [_c('div', {
        staticClass: "des"
      }, [_c('p', {
        staticClass: "des-title"
      }, [_vm._v(_vm._s(list.title))]), _vm._v(" "), _vm._l((list.dess), function(des, index) {
        return _c('p', {
          key: index,
          staticClass: "des-features"
        }, [_vm._v(_vm._s(des))])
      })], 2), _vm._v(" "), _c('div', {
        staticClass: "appointment cf"
      }, [_c('p', {
        staticClass: "price fl"
      }, [_vm._v(_vm._s(list.lowestPrice))]), _vm._v(" "), _c('span', {
        staticClass: "btn fr"
      }, [_vm._v("立即购买")])])])])
    })), _vm._v(" "), _c('div', {
      staticClass: "cf"
    }, [_c('img', {
      staticClass: "response fl",
      attrs: {
        "src": "static/images/activity_bottom.png"
      }
    })])])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "activity"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "outer-title"
  }, [_c('div', {
    staticClass: "inner-title"
  }, [_vm._v("活动规则")])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "cf"
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/images/activity_top.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main all-rules"
  }, [_c('ul', {
    staticClass: "all-rules-nav"
  }, _vm._l((_vm.activities), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: _vm.currentRule === index
      },
      on: {
        "click": function () {
          _vm.currentRule = index;
        }
      }
    }, [_c('div', [_c('p', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), (index === _vm.currentRule) ? _c('img', {
      attrs: {
        "src": "static/images/pre_seckill_bottom_arrow.png"
      }
    }) : _vm._e()])
  })), _vm._v(" "), _c('ul', {
    staticClass: "all-rules-rule"
  }, _vm._l((_vm.activities[_vm.currentRule].rules), function(rule, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      attrs: {
        "src": 'static/images/no.' + (index + 1) + '.png'
      }
    })]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(rule))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "cf"
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/images/activity_bottom.png"
    }
  })])])])], 2), _vm._v(" "), _c('m-footer')], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "fixed-btn"
  }, [_c('div', {
    staticClass: "text-btn"
  }, [_c('p', {
    on: {
      "click": function($event) {
        _vm.showMyPriceDialog = true
      }
    }
  }, [_vm._v("订单")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        _vm.showRules = true
      }
    }
  }, [_vm._v("规则")])]), _vm._v(" "), (_vm.showFixedBtn) ? _c('div', {
    staticClass: "to-top",
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "src": "static/images/to_top.png"
    }
  })]) : _c('div', {
    staticClass: "to-top",
    staticStyle: {
      "box-shadow": "none",
      "background-color": "rgba(0, 0, 0, 0)"
    }
  })]), _vm._v(" "), _c('x-dialog', {
    staticClass: "rules",
    model: {
      value: (_vm.showRules),
      callback: function($$v) {
        _vm.showRules = $$v
      },
      expression: "showRules"
    }
  }, [_c('div', {
    staticClass: "head cf"
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/images/rules_bg.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("活动规则")]), _vm._v(" "), _c('span', {
    staticClass: "vux-close",
    on: {
      "click": function($event) {
        _vm.showRules = false
      }
    }
  })]), _vm._v(" "), _c('div', [_c('tab', {
    attrs: {
      "active-color": "#fd424a"
    }
  }, _vm._l((_vm.activities), function(activity, index) {
    return _c('tab-item', {
      key: index,
      attrs: {
        "selected": _vm.currentRule === index
      },
      on: {
        "on-item-click": function($event) {
          _vm.currentRule = index
        }
      }
    }, [_vm._v(_vm._s(activity.title))])
  })), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, _vm._l((_vm.activities[_vm.currentRule].rules), function(rule, index) {
    return _c('p', {
      key: index
    }, [_vm._v(_vm._s(index + 1) + "、" + _vm._s(rule))])
  }))], 1)]), _vm._v(" "), _c('x-dialog', {
    attrs: {
      "scroll": true,
      "dialog-style": {
        'max-width': 'none',
        'background': 'transparent',
        'text-align': 'left',
        'overflow': 'visible'
      }
    },
    model: {
      value: (_vm.showMyPriceDialog),
      callback: function($$v) {
        _vm.showMyPriceDialog = $$v
      },
      expression: "showMyPriceDialog"
    }
  }, [_c('div', {
    staticClass: "coupons-dialog cf"
  }, [_c('img', {
    staticClass: "response fl",
    attrs: {
      "src": "static/images/coupon_bg.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "coupons-dialog-close",
    attrs: {
      "src": "static/images/close.png"
    },
    on: {
      "click": function($event) {
        _vm.showMyPriceDialog = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupons-dialog-btn"
  }, [_c('div', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('img', {
    staticClass: "response",
    attrs: {
      "src": "static/images/wx.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("查看订单请关注悟空保微信号iwukongbao，进入“我的>个人中心>我的订单”查看")]), _vm._v(" "), _c('p', {
    staticClass: "scratch-dialog-yes",
    on: {
      "click": function($event) {
        _vm.showMyPriceDialog = false
      }
    }
  }, [_vm._v("我知道了")])])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-tab-item",
    class: [_vm.currentSelected ? _vm.activeClass : '', {
      'vux-tab-selected': _vm.currentSelected,
      'vux-tab-disabled': _vm.disabled
    }],
    style: (_vm.style),
    on: {
      "click": _vm.onItemClick
    }
  }, [_vm._t("default"), _vm._v(" "), (typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '') ? _c('span', {
    staticClass: "vux-tab-item-badge",
    style: ({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })
  }, [_vm._v(_vm._s(_vm.badgeLabel))]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(423)
  __webpack_require__(424)
}
var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(436),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(434),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(431),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(435),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)


module.exports = Component.exports


/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(433),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(437),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(415)
}
var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(428),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(432),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(416)
}
var Component = __webpack_require__(25)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(429),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(163);
module.exports = __webpack_require__(162);


/***/ })

},[450]);


// WEBPACK FOOTER //
// static/js/app.092edec034d01836c5b4.js